import { render, staticRenderFns } from "./FormDescription.vue?vue&type=template&id=700ff81c&scoped=true"
import script from "./FormDescription.vue?vue&type=script&lang=js"
export * from "./FormDescription.vue?vue&type=script&lang=js"
import style0 from "./FormDescription.vue?vue&type=style&index=0&id=700ff81c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "700ff81c",
  null
  
)

export default component.exports